import { useDispatch } from "react-redux";
import { yodaBudgetActions } from "../actions";
import { yodaBudgetConstants } from "../constants";

const budgetReducer = (
  state = {
    loading: false,
    budget: null,
  },
  action,
) => {
  switch (action.type) {
    case yodaBudgetConstants.GETBUDGET_REQUEST:
      return {
        ...state,
        loading: true,
        //budget: null
      };

    case yodaBudgetConstants.GETBUDGET_SUCCESS:
      return {
        ...state,
        budget: action.payload.budget,
        loading: false,
      };

    case yodaBudgetConstants.GETBUDGET_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    default:
      return state;
  }
};

export default budgetReducer;
